import { DEFAULT_WEEK_STARTS_ON, getDayIndexInWeek, } from './week-start.utils';
/**
 * Converts a program type pattern string to an array of numbers
 * Example: '421' => [4, 2, 1]
 */
export function parseProgramType(programType) {
    return programType.split('').map(Number);
}
/**
 * Given a user's program pattern and a date, return the expected day type.
 *
 * Program patterns define how many days of each type in a week.
 * Example: '421' means 4 loss days, 2 maintenance days, 1 reward day.
 *
 * The pattern is relative to the user's week start (day index 0), not fixed
 * calendar weekdays. On Monday-start, 421 is Mon–Thu loss; on Sunday-start,
 * Sun–Wed loss.
 *
 * @param programType - String pattern like '421', '511', etc.
 * @param date - The date to calculate the day type for
 * @param weekStartsOn - 0=Sunday … 6=Saturday (default Monday)
 */
export function getExpectedDayType(programType, date, weekStartsOn = DEFAULT_WEEK_STARTS_ON) {
    const pattern = parseProgramType(programType);
    const normalizedDay = getDayIndexInWeek(date, weekStartsOn);
    let cursor = 0;
    const labels = ['loss', 'maintenance', 'reward'];
    for (let i = 0; i < pattern.length; i++) {
        cursor += pattern[i];
        if (normalizedDay < cursor) {
            return labels[i];
        }
    }
    return 'reward';
}
